import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Avatar } from 'antd';
import _ from 'lodash';
import moment from 'moment';
import i18n from 'i18next';

import { getChat, getChatDetails } from '../../store/chat/actions';
import { getChatState } from '../../store/chat/selector';
import { setLoading } from '../../store/app-globals/actions';
import { getUserState } from '../../store/user/selector';
import { getAppGlobalState } from '../../store/app-globals/selectors';

import { Navbar } from '../layout/Header';
import { EmptyContainer } from '../layout/EmptyContainer';
import { SkeletonLoading } from './components/Loading';

import ListIcon from '../../assets/images/png/chat-large.png';

export const ChaList: React.FC = () => {
  const { chat } = useSelector(getChatState);
  return (
    <Col xs={24} sm={24} md={14} lg={10} xl={10}>
      {chat.map((item, i) => {
        const latestMessage = _.last(item.message);
        const user = item.sender;
        const time = latestMessage && moment(latestMessage.timeadded).fromNow();
        return (
          <Link
            to={{
              pathname: '/chat/:',
              state: { user, chatid: item.id },
            }}
            key={i}
          >
            <Col span={22} className="chat-inner-container">
              <div style={{ width: '40px', height: '40px' }}>
                <Avatar src={item.sender.image} size="large" />
              </div>
              <div className="chat-wrapper">
                <div className="chat-head">
                  <div className="chat-head-name">{item.sender.firstName}</div>
                  <div className="chat-head-date">{time}</div>
                </div>
                <div className="chat-message chat-unread">
                  {latestMessage?.message}
                </div>
              </div>
            </Col>
          </Link>
        );
      })}
    </Col>
  );
};

export const Chat: React.FC = () => {
  const { chat } = useSelector(getChatState);
  const { isLoading } = useSelector(getAppGlobalState);
  const { user } = useSelector(getUserState);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLoading(true, 'Fetching Chat List'));
    dispatch(getChat());
    dispatch(getChatDetails());
  }, [dispatch, user]);

  return (
    <div className="dashboard">
      <Row justify="center">
        <Navbar />
      </Row>
      <Row justify="center" className="chat-container">
        {isLoading ? (
          <SkeletonLoading />
        ) : _.isEmpty(chat) ? (
          <EmptyContainer title={i18n.t('NO_CHAT_MESSAGE')} icon={ListIcon} />
        ) : (
          <ChaList />
        )}
      </Row>
    </div>
  );
};
